import { Pipe, PipeTransform } from '@angular/core';
import { Contact, Dependent, Individual } from '@models/profile/model';

@Pipe({ name: 'nameById' })
export class NameByIdPipe implements PipeTransform {
  public transform(id: string, users: Array<Individual | Dependent | Contact>): string {
    if (id && users) {
      const user = users.find((u) => u.id === id);
      if (user) {
        return `${user.firstName} ${user.lastName}`;
      }
      return '';
    }
    return '';
  }
}
